import script from "./CoreUiChatHistoryMessageStatus.vue?vue&type=script&lang=ts&setup=true"
export * from "./CoreUiChatHistoryMessageStatus.vue?vue&type=script&lang=ts&setup=true"

import "./CoreUiChatHistoryMessageStatus.vue?vue&type=style&index=0&id=635cd846&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-635cd846"]])

export default __exports__